<section id="ticketPage" class="flex flex-1 flex-col">
  <app-ticket-top
    [isLoading]="loadingAggregateStats()"
    [aggregate]="ticketAggregate()"
    [tickets]="(filteredTickets$ | async)?.data || []"
  >
  </app-ticket-top>
  <div class="lg2:grid-cols-8 grid flex-1 grid-cols-1 gap-2 md:grid-cols-2">
    <app-ticket-list-display
      class="lg2:col-span-5 min-w-0 overflow-hidden md:col-span-1"
      [totalTickets]="(filteredTickets$ | async)?.total || 0"
      [tickets]="(filteredTickets$ | async)?.data || []"
      [isLoading]="isLoadingFilteredTickets()"
      [csvData]="ticketCsvData()"
      (selectTicket)="onSelectTicket($event)"
      [canCreateTicket]="canCreateTicket()"
      (openCreateTicketDialog)="openDialog()"
      (timeRangeChanged)="onTimeRangeChanged($event)"
    ></app-ticket-list-display>

    <app-tickets-detail-shell
      class="lg2:col-span-3 sticky top-0 hidden h-svh min-w-0 self-start overflow-y-auto border-l border-gray-200 bg-white md:col-span-1 md:block"
      [isLoading]="isLoadingFilteredTickets()"
    ></app-tickets-detail-shell>
  </div>
</section>
